/**
 * This file is a main file of extractor evaluation strategy.
 * It finds __linariaPreval statements starting from the end of the program and
 * invoke RequirementsResolver to get parts of code that needs to be executed in order to evaluate the dependency.
 */

const extractor = () => {
  throw new Error(
    'Extractor strategy is obsolete. Please use @linaria/shaker instead.'
  );
};

export default extractor;
